import type { CancelablePromise } from "@/clients/core/CancelablePromise";

export const resolveCancelableQuery = async <T>(
  request: CancelablePromise<T>,
  signal?: AbortSignal,
): Promise<T> => {
  if (!signal) {
    return request;
  }

  const cancelRequest = () => {
    request.cancel();
  };

  if (signal.aborted) {
    cancelRequest();
    return request;
  }

  signal.addEventListener("abort", cancelRequest, { once: true });

  try {
    return await request;
  } finally {
    signal.removeEventListener("abort", cancelRequest);
  }
};
